import React from 'react'

import { Link } from 'react-router-dom';


function WalletDetails({title, image, balanceLabel, balanceValue, historyPath, stateData, variant}) {


  return (
    // <div className="wallet-section">
        // <div className="wallet-card">
        <div className={`wallet-card ${variant}`}>
            <h3>{title}</h3>

            <img src={image} alt={title} className="wallet-img" />

            {balanceLabel && <p className="balance-label">{balanceLabel}</p>}

            <h2 className="balance-value">{balanceValue}</h2>

            {/* Show link only if path is provided */}
            {historyPath && (
                <Link
                to={historyPath}
                state={stateData}
                className="wallet-link"
                >
                Transaction History &gt;&gt;
                </Link>
            )}
        </div>
    // </div>
  )
}

export default WalletDetails